export class SchedulingGroup {
    constructor(public name: string, public size: number) { }
}
